/* eslint-disable
    eqeqeq,
    */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import { customFieldsId as CUSTOM_FIELDS_ID } from '@trello/config';

import { sendPluginViewedComponentEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
import { CustomFieldBadgeView } from 'app/scripts/views/custom-field/CustomFieldBadgeView';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { View } from 'app/scripts/views/internal/View';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let lastIdBoard: any = null;
let trackedFrontBadges = false;

interface CustomFieldBadgesView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  badgeView: any;
}

class CustomFieldBadgesView extends View {
  static initClass() {
    this.prototype.tagName = 'span';
    this.prototype.badgeView = CustomFieldBadgeView;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  idForBadge(customField: any, customFieldItem: any) {
    let idParts = [
      customField.id,
      customField.name,
      JSON.stringify(customField.options),
    ];
    if (customFieldItem) {
      idParts.push(customFieldItem.id);
      if (customFieldItem.idValue) {
        idParts.push(customFieldItem.idValue);
      } else {
        idParts = idParts.concat([
          customFieldItem.color,
          JSON.stringify(customFieldItem.value),
        ]);
      }
    }

    return idParts.join(':');
  }

  render() {
    const board = this.model.getBoard();
    if (board.id !== lastIdBoard) {
      lastIdBoard = board.id;
      trackedFrontBadges = false;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const subviews = board.customFieldList.map((customField: any) => {
      const customFieldItem = this.model.getCustomFieldItem(customField.id);
      //filter out those that aren't supposed to show on card front
      if (
        !(customFieldItem != null
          ? customFieldItem.showFrontBadge()
          : undefined)
      ) {
        return null;
      }
      const viewId = this.idForBadge(
        customField.toJSON(),
        customFieldItem.toJSON(),
      );
      return this.subview(
        this.badgeView,
        this.model,
        { customFieldItem, customField },
        viewId,
      );
    });

    const compacted = _.compact(subviews);
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    this.ensureSubviews(compacted);

    if (compacted.length > 0) {
      this.trackBadges();
    }

    return this;
  }

  trackBadges() {
    if (!trackedFrontBadges) {
      trackedFrontBadges = true;
      // ensure we have the Custom Fields plugin model before sending the event
      // b/c without the model's info, the tracking event will fail
      return pluginRunner
        .getOrLoadPlugin(this.model.getBoard(), CUSTOM_FIELDS_ID)
        .then(() => {
          return sendPluginViewedComponentEvent({
            idPlugin: CUSTOM_FIELDS_ID,
            idBoard: this.model.getBoard().id,
            idCard: this.model.id,
            event: {
              componentType: 'badge',
              componentName: 'pupCardBadge',
              source: 'boardScreen',
            },
          });
        });
    }
  }
}

CustomFieldBadgesView.initClass();
export { CustomFieldBadgesView };
